import { cleanUndefined } from './clean-undefined';

export const objToSearchFilter = filterObj => {
	if (!filterObj) return undefined;
	filterObj = cleanUndefined(filterObj);
	const keys = Object.keys(filterObj);
	let searchFilter = keys
		.map((k, idx) => {
			if (filterObj[k] !== undefined && filterObj[k] !== '' && filterObj[k] !== null)
				return `${k}==${filterObj[k]}${idx === keys.length - 1 ? '' : '&&'}`;
		})
		.join('');
	return searchFilter;
};
